<template>
    <div class="listItemBox">
        <div class="listItem">
            <div class="item">
                <el-image :src=" Item['Cover'] || Item['FileUrl']" lazy class="leftImg" placeholder="加载中"  >
                                         <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
                    
                </el-image>

                <!-- <img :src=" Item['Cover'] || Item['FileUrl']" class="leftImg"> -->
                <div>{{Item['Title']}}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        Item:{
            type:Object,
        }
    },
    data(){
        return{
            url:'https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg',
        }
    }
}
</script>
<style lang="scss" scoped>
.listItemBox{
    width: calc(100% / 3);
    display: inline-block;
    margin-top:50px;
    float: left;
        .listItem{
        display: inline-flex;
        width: 100%;
        // justify-content: space-evenly;
        flex-wrap: wrap;
        .item{      
           margin-bottom: 30px;
            .leftImg{
                 height: 230px;
                 width: 350px;
            }
            div{
                margin-top:5px;
                width: 350px;
                font-size: 14px;
                font-weight: 400;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                &:hover{
                    color:rgba(65, 96, 206, 1);
                }
            }
        }
        .item:nth-child(3n+2){
            margin: 0 calc(calc(100% - 350px * 3) / 2);
        }
       
    }
}

</style>